import MkuOptionsGroup from '../select/src/options-group';

MkuOptionsGroup.install = function (Vue) {
  Vue.component(MkuOptionsGroup.name, MkuOptionsGroup);
};

export default MkuOptionsGroup;
